import { AddCerosToNumber } from "../actions/actions";
import { INumeroExtracto } from "../interfaces/interfaces";
import { v4 as uuid } from "uuid";

interface Props {
  numerosExtractos: INumeroExtracto[];
  stateProxSorteo: number;
}

const ResumenPoceada = (props: Props) => {
  const { numerosExtractos, stateProxSorteo } = props;
  let numerosPoceada = getNumerosPorModalidad(30, numerosExtractos);

  const diffHours = Math.floor((stateProxSorteo * -1) / 60);
  const diffMinutes = (stateProxSorteo * -1) % 60;

  return (
    <>
      <div id="ResumenPOC" className="resumenSorteoPOC">
        <div className="extractoResumenHead">
          <div className="extractoResumenTitulo">Poceada Federal</div>
        </div>
        <div className="extractoResumenContainer">
          <div className="extractoResumenMedio">
            {numerosPoceada &&
              numerosPoceada.length > 0 &&
              getNumerosPoceada(numerosPoceada)}
          </div>
        </div>
      </div>

      <div id="ProximoSorteo">
        <span className="proxSorteo">Próximo Sorteo:</span>
        <div className="proxSorteoTime">{`${diffHours}h ${diffMinutes}m`}</div>
      </div>
    </>
  );

  function getNumerosPoceada(numeros: INumeroExtracto[]) {
    let arrayArriba: JSX.Element[] = [];
    let arrayAbajo: JSX.Element[] = [];

    for (const numero of numeros) {
      let keyC = `colkeyP${numero.idModalidad}${uuid()}`;

      if (numero.Ubicacion % 2 !== 0) {
        arrayArriba.push(
          <div key={keyC}>
            <div className="extractoNumeroResumen">
              {AddCerosToNumber(numero.Valor, 2)}
            </div>
          </div>
        );
      } else {
        arrayAbajo.push(
          <div key={keyC}>
            <div className="extractoNumeroResumen">
              {AddCerosToNumber(numero.Valor, 2)}
            </div>
          </div>
        );
      }
    }

    return (
      <>
        <div className="extractoBloqueNumResumen">{arrayArriba}</div>
        <div className="extractoBloqueNumResumen">{arrayAbajo}</div>
      </>
    );
  }

  function getNumerosPorModalidad(
    idModalidad: number,
    numerosExtractos: INumeroExtracto[]
  ) {
    return [
      ...numerosExtractos.filter(
        (numero) => numero.idModalidad === idModalidad
      ),
    ];
  }
};

export default ResumenPoceada;
